/* Keep checkout behind Shopify cart writes and the order-summary refresh. */
(function () {
  if (window.AldenoCheckoutSync) return;
  var pending = 0;
  var failed = false;
  var checkoutSelector = '[name="checkout"], [name="goto_pp"], [name="goto_gc"], a[href="/checkout"]';

  function render() {
    document.querySelectorAll(checkoutSelector).forEach(function (button) {
      if (pending || failed) {
        if (!button.hasAttribute('data-cart-sync-disabled')) {
          button.setAttribute('data-cart-sync-disabled', button.disabled ? 'already' : 'sync');
        }
        button.disabled = true;
        button.setAttribute('aria-busy', pending ? 'true' : 'false');
      } else if (button.hasAttribute('data-cart-sync-disabled')) {
        if (button.getAttribute('data-cart-sync-disabled') === 'sync') button.disabled = false;
        button.removeAttribute('data-cart-sync-disabled');
        button.removeAttribute('aria-busy');
      }
    });
    document.querySelectorAll('[data-cart-sync-status]').forEach(function (status) {
      status.textContent = failed ? 'Your cart could not be updated. Please refresh this page before checking out.' :
        pending ? 'Updating your cart…' : '';
    });
  }

  window.AldenoCheckoutSync = {
    begin: function () {
      pending++;
      render();
      var finished = false;
      return function (success) {
        if (finished) return;
        finished = true;
        pending--;
        if (!success) failed = true;
        render();
      };
    }
  };

  // Capture runs before Razorpay's delegated checkout listener, including
  // when an AJAX section replaces the previously disabled button.
  function guard(event) {
    var checkout = event.type === 'submit' ? event.submitter : event.target.closest(checkoutSelector);
    if ((pending || failed) && (checkout || event.type === 'submit' && event.target.matches('form[action*="/cart"]'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      render();
    }
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
})();
